<template>
  <v-dialog
    width="600px"
    :title="title"
    :visible.sync="dialogVisible"
    @close="onClose"
    @closed="onClosed"
    split-line
  >
    <el-form class="padding-lr" v-if="data" label-width="190px">
      <template v-if="data.FromAnzo">
        <el-form-item label="Content Category">
          <span>{{ data.CategoryName }}</span>
        </el-form-item>
        <el-form-item label="Short Title">
          <span>{{ data.ShortTitle }}</span>
        </el-form-item>
        <el-form-item label="Search Term">
          <span>{{ data.SearchTerm }}</span>
        </el-form-item>
        <el-form-item label="Allow Full Article Request">
          {{ data.FullPaperRequest === 1 ? "Yes" : "No" }}
        </el-form-item>
        <el-form-item label="Any Comments">
          <div ref="commentWrapper" class="any-comments-wrapper">
            {{ data.AnyComments }}
          </div>
        </el-form-item>
      </template>
      <template v-else>
        <template v-if="data.CategoryName">
          <el-form-item label="Content Category">
            <span>{{ data.CategoryName }}</span>
          </el-form-item>
          <el-form-item label="Content Title">
            <span>{{ data.DocumentTitle }}</span>
          </el-form-item>
          <el-form-item label="Search Term">
            <span>{{ data.SearchTerm }}</span>
          </el-form-item>
          <el-form-item label="Security Level">
            <span>{{ data.levelName }}</span>
          </el-form-item>
          <el-form-item label="PDF Attached">
            <a :href="data.AttachmentPath" target="blank">{{
              data.FileName
            }}</a>
          </el-form-item>
          <el-form-item label="Allow Full Article Request">
            {{ data.FullPaperRequest === 1 ? "Yes" : "No" }}
          </el-form-item>
          <el-form-item label="Content">
            <div
              ref="contentWrapper"
              class="content-wrapper"
              v-html="data.PaperContent"
            ></div>
          </el-form-item>
        </template>
        <template v-else-if="data.PushType === 'Quick Push'">
          <el-form-item label="Title">
            <span>{{ data.ShortTitle }}</span>
          </el-form-item>
          <el-form-item label="Business Purpose">
            <span>{{ data.purposeName }}</span>
          </el-form-item>
          <el-form-item label="Security Level">
            <span>{{ data.levelName }}</span>
          </el-form-item>
          <el-form-item label="Request">
            <span>{{ data.Inquiry }}</span>
          </el-form-item>
          <el-form-item label="VV Number">
            <span>{{ data.vvNumber }}</span>
          </el-form-item>
          <el-form-item label="Content">
            <div
              ref="contentWrapper"
              class="content-wrapper"
              v-html="data.PaperContent"
            ></div>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="Select Meeting" label-width="120px">
            <span>{{ data.ShortTitle }}</span>
          </el-form-item>
          <el-form-item
            class="content-container"
            label="Content"
            label-width="120px"
          >
            <div
              ref="contentWrapper"
              class="content-wrapper"
              v-html="data.PaperContent"
            ></div>
          </el-form-item>
        </template>
      </template>
    </el-form>
  </v-dialog>
</template>
<script>
export default {
  name: "view-content-dialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: false,
    },
    data: Object,
  },
  data() {
    return {
      dialogVisible: this.visible,
    };
  },
  computed: {
    url() {
      return this.data
        ? `${process.env.VUE_APP_SERVER}/upload/paper/${this.data.Attachment}`
        : "/";
    },
    title() {
      if (this.data) {
        if (!this.data.FromAnzo) {
          if (this.data.CategoryName) {
            return "View New Paper";
          } else {
            return `View Content`;
          }
        } else {
          return "View Upload Content";
        }
      } else {
        return "View Paper";
      }
    },
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
  },
  methods: {
    onClose() {
      const commentWrapper = this.$refs.commentWrapper;
      if (commentWrapper) {
        commentWrapper.scrollTop = 0;
      }
      const contentWrapper = this.$refs.contentWrapper;
      if (contentWrapper) {
        contentWrapper.scrollTop = 0;
      }
      this.$emit("close");
    },
    onClosed() {
      this.$emit("update:data", null);
      this.$emit("update:visible", false);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .el-scrollbar.dialog {
    max-height: 100%;
    width: 600px;
    min-width: 600px;
    min-height: 10vw;
    .el-scrollbar__wrap {
      margin-bottom: 0 !important;
    }
  }
  .el-dialog__header {
    padding: 20px;
  }
  .el-form-item__label {
    color: #555;
    font-weight: bold;
  }
  .el-dialog__footer {
    padding: 0;
  }
  .el-dialog__body {
    padding: 0px;
    display: flex;
    max-height: 70vh;
  }
}
.el-form {
  position: relative;
  padding: 30px 40px 15px 15px;
  .el-form-item.content-container {
    margin-bottom: 0px;
  }
}
.link-wrap {
  max-width: 95%;
}
.any-comments-wrapper {
  padding-right: 30px;
  word-break: break-word;
  max-height: 200px;
  overflow: scroll;
  padding-right: 10px;
}
.content-wrapper {
  font-size: 14px;
  display: inline-block;
  min-height: 50px;
  max-height: 180px;
  overflow: scroll;
  width: 100%;
  padding-right: 10px;
  ::v-deep {
    ol {
      display: block;
      list-style-type: decimal;
      margin-block-start: 1em;
      margin-block-end: 1em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      padding-inline-start: 40px;
      li {
        list-style: decimal;
      }
    }
    li {
      display: list-item;
      text-align: -webkit-match-parent;
    }
    ul {
      display: block;
      list-style-type: disc;
      margin-block-start: 1em;
      margin-block-end: 1em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      padding-inline-start: 40px;
      li {
        list-style: disc;
      }
    }
    ol ul {
      list-style-type: circle;
      margin-block-start: 0px;
      margin-block-end: 0px;
      li {
        list-style: circle;
      }
    }
    ul ol {
      margin-block-start: 0px;
      margin-block-end: 0px;
    }
    ul ul {
      list-style-type: circle;
      margin-block-start: 0px;
      margin-block-end: 0px;
      li {
        list-style: circle;
      }
    }
    ol ol {
      margin-block-start: 0px;
      margin-block-end: 0px;
    }
    ul ul ul {
      list-style-type: square;
      li {
        list-style: square;
      }
    }
    //默认样式--end
    figure {
      display: inherit;
    }
    img {
      max-width: 250px;
      height: auto;
    }
    video {
      width: 100% !important;
      height: auto !important;
    }
  }
}
</style>
